{
  "moreActions": "További lehetőségek",
  "unavailable": "Nem érhető el, a részletekért bontsa ki"
}
